import { useEffect, useState } from "react";

export default function OktaUserIdentifier({ email: emailProp, className = "" }) {
  const [email, setEmail] = useState(emailProp || "");

  useEffect(() => {
    if (emailProp) {
      setEmail(emailProp);
    } else {
      setEmail(localStorage.getItem("userEmail") || localStorage.getItem("username") || "");
    }
  }, [emailProp]);

  if (!email) return null;

  return (
    <div
      className={`identifier-container okta-identifier-container ${className}`.trim()}
      title={email}
    >
      <span className="identifier">{email}</span>
    </div>
  );
}
